export default __webpack_public_path__ + "static/media/il_support_right.2509f383.svg";